import restoreLogin from './utils/restoreLogin'
import checkBuildVersion from './utils/check-build-version'

// 先恢复登录信息，再加载应用及其依赖。
checkBuildVersion().then(() => {
  restoreLogin(() => {
    require('./bootstrap')
  })
})



// WEBPACK FOOTER //
// ./src/main.js